//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";
import { STATIONS } from "utils/config/reference";

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const widgetsInit = {
  users: [],
  selectedUser: [],
  openVocabCognates: {
    open: false
  }
};

export const widgetWheelReducer = (state = widgetsInit, action) => {
  switch (action.type) {
    case ActionTypes.widgetWheel.updateUser:
      return { ...state, users: action.payload };
    case ActionTypes.widgetWheel.updateSelectedUser:
      return { ...state, selectedUser: action.payload };
    case ActionTypes.widgetWheel.updateVocabCognates:
        return { ...state, openVocabCognates: {...state?.openVocabCognates, ...action.payload}};
    default:
      return state;
  }
};

const widgetGroupInit = {
  users: [],
  selectedUser: [],
  generatedGroup: [],
  studentPerGroup: 0,
};

export const widgetGroupReducer = (state = widgetGroupInit, action) => {
  switch (action.type) {
    case ActionTypes.widgetGroup.update:
      return {...state, ...action.payload}
    default:
      return state;
  }
};

const widgetStationInit = {
  users: [],
  selectedUser: [],
  stations: STATIONS,
  generatedGroup: [],
  studentPerGroup: 0,
}


export const widgetStationReducer = (state = widgetStationInit, action) => {
  switch (action.type) {
    case ActionTypes.widgetStation.update:
      return {...state, ...action.payload}
    default:
      return state;
  }
};
